import React, { useContext, useReducer, useMemo } from "react";
import Modal from '../components/Modal/Modal';
import { actions } from "../actions/error";
import { parseErrorMessage } from "../utils/functions";

const initialState = {
    open: false,
    message: '',
    onCloseCallback: null
};

const ErrorContext = React.createContext({
    state: null,
    dispatch: null,
});

function closeAndLogout(payload) {
    return { open: true, message: payload.message, onCloseCallback: payload.onCloseCallback }
}

function reducer(state, action) {
    switch (action.type) {
        case actions.OPEN_MODAL:
            return { open: true, message: action.payload };
        case actions.CLOSE_MODAL:
            return { open: false, message: '' };
        case actions.CLOSE_AND_CALLBACK:
            return closeAndLogout(action.payload);
        default:
            return state;
    }
}

export const ErrorProvider = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initialState);

    const contextValue = useMemo(() => {
        return { state, dispatch };
    }, [state, dispatch]);

    const handleClose = () => {
        dispatch({type: actions.CLOSE_MODAL});
        if(state.onCloseCallback)
            state.onCloseCallback();
    }

    return <ErrorContext.Provider value={contextValue}>
        {children}
        <Modal open={state.open} handleClose={handleClose} title="Error">
            <span color="textPrimary">{parseErrorMessage(state.message)}</span>
        </Modal>
    </ErrorContext.Provider>
}


export const useErrorProvider = () => useContext(ErrorContext);